import { useFlags } from 'launchdarkly-react-client-sdk';
import { GqlDispensaries } from 'types/graphql';
import { MISSING_PRODUCT_BRAND_PLACEHOLDER_ID } from 'shared/constants';
import { Product } from 'src/utils/helpers/product';
import _sortBy from 'lodash/sortBy';

type UseSortProductsByCustomBrandsortParams = {
  products: Product[];
  dispensary: GqlDispensaries | undefined;
  isDefaultSort: boolean;
  types: string[];
};

/**
 * @deprecated This hook is part of menu v1 implementation and will be skipped when menu v2 is enabled.
 * TODO: Remove this hook when menu v1 is fully deprecated.
 */
export function useSortProductsByCustomBrandsort({
  products,
  dispensary,
  isDefaultSort,
  types,
}: UseSortProductsByCustomBrandsortParams): Omit<
  UseSortProductsByCustomBrandsortParams,
  'dispensary' | 'isDefaultSort' | 'types'
> {
  const flags = useFlags();
  const isMenuV2Enabled = flags['ecomm.admin.menu-v2.rollout'] ?? false;

  // This is menu v1 logic, exit early if v2 is enabled
  if (isMenuV2Enabled) {
    return { products };
  }

  const { menuOrder, menuSortSettings } = dispensary ?? {};
  const [queryCategory] = types;
  const categorySortSettings = menuSortSettings?.find((sortSettings) => sortSettings.category === queryCategory);

  if (!isDefaultSort || menuOrder !== 'brand') {
    return { products };
  }

  const productsSortedByBrand = _sortBy(products, [
    (product) => {
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      const productBrandId = product.brand?.id ?? MISSING_PRODUCT_BRAND_PLACEHOLDER_ID;
      const brandIndex = categorySortSettings?.brands?.indexOf(productBrandId);
      return brandIndex === -1 ? 1000 : brandIndex;
    },
    `weight`,
  ]);

  return { products: productsSortedByBrand };
}
